<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">{{
        props.id == null ? 'Create Task' : 'Edit Task'
      }}</oxd-text>
      <oxd-divider />

      <oxd-form :loading="isLoading" @submitValid="onSave">
        <oxd-form-row>
          <oxd-grid :cols="2" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.title"
                label="Title"
                placeholder="Title"
                :rules="rules.title"
                required
                autocomplete="off"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.description"
                type="textarea"
                label="Description"
                placeholder="Description"
                autocomplete="off"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-divider />
        <oxd-form-actions>
          <required-text />
          <oxd-button
            type="button"
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script setup>
import {inject, onBeforeMount, ref, defineEmits, defineProps} from 'vue';
import {required} from '@ohrm/core/util/validation/rules';
import {APIService} from '@/core/util/services/api.service';
import {navigate} from '@/core/util/helper/navigation';

const $toast = inject('$toast');

const emit = defineEmits(['onCancel', 'afterSubmit']);

const props = defineProps({
  id: {type: Number, default: null},
  isModal: {type: Boolean, default: false},
});

const form = ref({title: '', description: ''});
const rules = {title: [required]};
const isLoading = ref(false);
const http = new APIService(window.appGlobal.baseUrl, 'api/task');

onBeforeMount(() => {
  if (props.id != null) {
    http
      .request({
        method: 'GET',
        url: `api/task/${props.id}`,
      })
      .then(response => {
        form.value = response.data;
      });
  }
});
const onSave = () => {
  isLoading.value = true;
  http
    .request({
      method: props.id != null ? 'PUT' : 'POST',
      data: form.value,
    })
    .then(response => {
      props.id != null ? $toast.updateSuccess() : $toast.saveSuccess();
      if (props.isModal) {
        emit('afterSubmit', {id: response.data.id, title: response.data.title});
      } else {
        navigate('/admin/viewTaskList');
      }
    })
    .catch(() => {
      $toast.unexpectedError();
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const onCancel = () => {
  if (props.isModal) {
    emit('onCancel');
  } else {
    navigate('/admin/viewTaskList');
  }
};
</script>
